import {AccordionLinkGroup} from 'shared/pretty-easy-navigation/models';
import {DictionaryLink, LanguageLaboratoryLink, UserLessonListLink} from '../links';
import {NavigationContext} from '../navigation.context';

export const ToolsGroup = (context: NavigationContext): AccordionLinkGroup => ({
    type: 'accordionLinkGroup',
    label: 'navigation.tools',
    links: [
        UserLessonListLink(context),
        DictionaryLink(context),
        LanguageLaboratoryLink(context)
    ],
    icon: 'navigation-group__tools',
});

